/**
 * Barra de objetivos del carrito PadelHouse (Bloque 3, 2026-07-24; rediseno v2 estetica).
 *
 * Se carga GLOBAL desde sections/ph-footer.liquid. Hace tres cosas:
 *   1) BARRA DE ENVIO GRATIS: progreso hacia 100 EUR (mismo umbral que anuncia la tienda).
 *   2) REGALO POR UMBRAL: >50 EUR overgrips.
 *   3) Se pinta en el DRAWER y en /cart, y recalcula con cart:update.
 *
 * Diseno v2: tarjeta blanca + acento azul de marca #0f9afa, barra con degradado (azul ->
 * verde al conseguir envio gratis), tramos con check, caja de regalo azul. SIN modo oscuro
 * (el storefront de Horizon es siempre claro; el override dark dejaba el texto invisible).
 * Sin dependencias, sin emojis (iconos SVG inline). IIFE con guarda de doble carga.
 *
 * ===========================================================================
 * REVISION 2026-08-18 - dos fallos que reporto Raul, con la misma raiz cada uno
 * ===========================================================================
 *
 * FALLO 1: "los regalos no se anaden solos y hay que refrescar para verlos".
 *
 *   Eran dos cosas encadenadas:
 *
 *   a) El regalo NUNCA se anadia solo: habia un boton "Anadir". Ahora se anade
 *      y se quita solo (ver gestionarRegalos), que es lo que se espera de un
 *      regalo por umbral.
 *
 *   b) Y cuando se anadia, el carrito no se repintaba. Este codigo llamaba a
 *      `window.phAddToCart` y, si no existia, caia a /cart/add.js + un evento
 *      `cart:refresh`. Resulta que:
 *        - `window.phAddToCart` NO EXISTE en ninguna parte del tema. Lo llaman
 *          tres archivos (este, ph-upsells.js y el multipack) siempre detras de
 *          un `typeof === 'function'`, asi que los tres caian al respaldo sin
 *          hacer ruido.
 *        - `cart:refresh` NO EXISTE en Horizon. El unico evento de carrito es
 *          `cart:update` (ver assets/events.js, ThemeEvents.cartUpdate). Nadie
 *          escuchaba `cart:refresh`, asi que las lineas del carrito se quedaban
 *          como estaban hasta recargar la pagina.
 *
 *      Y no basta con renombrar el evento: `CartItemsComponent.#handleCartUpdate`
 *      (assets/component-cart-items.js) lee `event.detail.data.sections`. Un
 *      `new CustomEvent('cart:update')` pelado tiene `detail === null` y ahi
 *      revienta con TypeError. Hay que mandar el evento con la forma que espera
 *      el tema y, sobre todo, PEDIR las secciones renderizadas en la propia
 *      llamada a /cart/add.js (parametros `sections` y `sections_url`), igual que
 *      hace Horizon en su updateQuantity().
 *
 *      Como los otros dos archivos ya preguntaban por `window.phAddToCart`, aqui
 *      se DEFINE de una vez. Con eso ph-upsells.js (botones [data-ph-add] de los
 *      upsells y de "vistos recientemente") empieza a refrescar bien sin tocarlo.
 *
 * FALLO 2: "no son acumulativos, uno elimina al otro".
 *
 *   Esto NO es del tema, es un limite de Shopify. Los dos regalos son descuentos
 *   automaticos Buy X Get Y y los dos piden lo mismo: gastar >=50 / >=150 EUR en
 *   las colecciones Palas de padel + Proteccion y Recuperacion + Voleibol. La
 *   documentacion de Shopify lo dice tal cual, en todas las versiones de la API:
 *
 *     "Buy X Get Y discounts stack only on the customer-gets products (GY),
 *      not the customer-buys products (BX)."
 *     https://shopify.dev/docs/api/admin-graphql/2026-07/objects/DiscountCombinesWith
 *
 *   Es decir: la pala solo puede hacer de "X" para UNO de los dos descuentos. El
 *   otro se queda sin prerequisito y no salta. Por eso en el carrito de Raul el
 *   paletero salia a 0,00 EUR y el overgrip se COBRABA a 9,00 EUR.
 *
 *   Mientras los regalos sigan siendo dos BXGY, lo unico honesto es llevar UN
 *   regalo en la cesta: el del tramo mas alto alcanzado. Eso es justo lo que
 *   promete la nota del panel, y es lo que hace ahora gestionarRegalos(): anade
 *   el de arriba y quita el de abajo. Antes el de abajo se quedaba dentro y el
 *   cliente lo pagaba sin enterarse.
 *
 *   Si algun dia se cambia el mecanismo (variantes a 0 EUR o una Shopify
 *   Function), poner ACUMULATIVOS = true y ya se llevan los dos.
 *
 * ===========================================================================
 * CAMBIO 2026-08-21 - retirado el regalo de paletero (>150 EUR)
 * ===========================================================================
 *
 *   Decision de Raul: se elimina el upsell "paletero gratis desde 150 EUR".
 *   Queda UN solo tramo de regalo, los overgrips a partir de 50 EUR.
 *
 *   Efecto secundario bueno: el FALLO 2 de aqui arriba desaparece solo. Ya no
 *   hay dos BXGY compitiendo por el mismo prerequisito, asi que el regalo que
 *   queda salta siempre y nunca se le cobra al cliente por sorpresa. ACUMULATIVOS
 *   deja de tener efecto practico mientras GIFTS tenga un unico elemento.
 *
 *   Para volver a activarlo: reponer la linea en GIFTS
 *   ({ at: 15000, id: 60165386993998, label: 'Paletero de regalo' }) y reactivar
 *   el descuento automatico "Regalo PadelHouse - Paletero gratis desde 150 EUR"
 *   (DiscountAutomaticNode/2288187310414), que se ha dejado desactivado, no
 *   borrado. Releer entonces el FALLO 2, que vuelve a aplicar.
 *
 * OJO, dos desajustes conocidos que NO se arreglan aqui porque son de negocio:
 *   - El umbral que mide este JS es el subtotal del carrito SIN contar las lineas
 *     de regalo. El que mide Shopify es solo el gasto en esas tres colecciones.
 *     Un carrito de 160 EUR de paleteros desbloquea el regalo aqui y no alli.
 *   - El regalo lo controla el navegador. Shopify sigue siendo quien decide el
 *     precio final en el checkout, asi que el descuento manda sobre lo que diga
 *     este panel.
 */
(function () {
  'use strict';
  if (window.__phCartGoalsReady) return;
  window.__phCartGoalsReady = true;

  var FREE_SHIP = 10000; // 100,00 EUR en centimos

  /* Ordenado de menor a mayor: varias partes del codigo dan por hecho que el
     ultimo elemento es el tramo mas alto. */
  var GIFTS = [
    { at: 5000,  id: 60148339638606, label: 'Overgrips de regalo' }
  ];

  /* false = un solo regalo en la cesta, el del tramo mas alto alcanzado.
     Es lo unico que Shopify puede cobrar bien hoy: los dos regalos son
     descuentos Buy X Get Y y comparten prerequisito, asi que solo salta uno
     (ver la explicacion larga de la cabecera). Con dos regalos dentro, el de
     abajo se COBRA.
     Ponlo a true el dia que los regalos dejen de depender de dos BXGY. */
  var ACUMULATIVOS = false;

  /* Regalos que el cliente ha quitado a mano. Si no se guardase, volveriamos a
     metérselos en el carrito acto seguido y no habria forma de rechazarlos.
     sessionStorage y no localStorage: es una decision de esta compra, no para
     siempre. */
  var CLAVE_RECHAZADOS = 'ph_regalos_rechazados';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root : '/').replace(/\/$/, '');

  function euro(cents) {
    var n = Number(cents);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(n / 100); }
    catch (e) { return (n / 100).toFixed(2).replace('.', ',') + ' EUR'; }
  }

  function esRegalo(variantId) {
    for (var i = 0; i < GIFTS.length; i++) if (GIFTS[i].id === variantId) return true;
    return false;
  }

  function leerRechazados() {
    try {
      var raw = window.sessionStorage.getItem(CLAVE_RECHAZADOS);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function rechazar(id) {
    var arr = leerRechazados();
    if (arr.indexOf(id) === -1) arr.push(id);
    try { window.sessionStorage.setItem(CLAVE_RECHAZADOS, JSON.stringify(arr)); } catch (e) {}
  }

  function estaRechazado(id) { return leerRechazados().indexOf(id) !== -1; }

  /* ---- iconos ---- */
  var SHIP_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h11v10H3V6Zm11 3h4l3 3v4h-7V9ZM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var GIFT_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2V7Zm10 0v14M12 7S9.5 2.5 7 4s.5 3 5 3Zm0 0s2.5-4.5 5-3-.5 3-5 3Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5 10 17l9-10" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 10V8a5 5 0 0 1 10 0v2m-11 0h12v10H6V10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---- estilos (una sola vez) ---- */
  function injectStyle() {
    if (document.getElementById('ph-cart-goals-css')) return;
    var css = [
      '.ph-goals{--pg-accent:#0f9afa;--pg-accent-dk:#0b6fb8;--pg-ok:#12a150;--pg-ink:#0d1420;',
      '--pg-muted:#5b6672;--pg-line:rgba(13,20,32,.09);--pg-tile:#eef3f9;',
      "font-family:var(--font-body--family,'Inter',sans-serif);background:#fff;border:1px solid var(--pg-line);",
      'border-radius:16px;padding:16px 18px;margin:4px 0 22px;box-shadow:0 8px 22px -16px rgba(13,20,32,.4);box-sizing:border-box;}',
      /* 17-08. En /cart el panel iba a 760px y CENTRADO, mientras el carrito
         respeta el ancho de pagina y arranca a 40px del borde. Quedaban dos
         anchos distintos apilados. Ahora usa la misma cuenta que las secciones
         nativas de Horizon, asi que su borde izquierdo cae donde el titulo. */
      '[data-ph-goals-page]{width:min(var(--page-content-width,75rem),calc(100% - var(--page-margin,40px)*2));',
      'margin:0 auto 22px;}',
      '.ph-goals *{box-sizing:border-box;}',
      '.ph-goals__msg{display:flex;align-items:center;gap:9px;font-size:.9rem;font-weight:700;color:var(--pg-ink);line-height:1.3;margin:0 0 12px;}',
      '.ph-goals__msg svg{width:20px;height:20px;flex:0 0 auto;color:var(--pg-accent);}',
      '.ph-goals__msg.is-ok{color:var(--pg-ok);}.ph-goals__msg.is-ok svg{color:var(--pg-ok);}',
      '.ph-goals__msg b{color:var(--pg-accent);font-weight:800;white-space:nowrap;}',
      '.ph-goals__msg.is-ok b{color:var(--pg-ok);}',
      '.ph-goals__track{position:relative;height:10px;border-radius:99px;background:var(--pg-tile);overflow:hidden;}',
      '.ph-goals__fill{position:absolute;inset-block:0;inset-inline-start:0;border-radius:99px;min-width:10px;',
      'background:linear-gradient(90deg,#0f9afa,#38b6ff);transition:width .45s cubic-bezier(.4,0,.2,1);}',
      '.ph-goals.is-ship .ph-goals__fill{background:linear-gradient(90deg,#12a150,#31d07d);}',
      '.ph-goals__tiers{list-style:none;margin:13px 0 0;padding:0;display:flex;flex-direction:column;gap:9px;}',
      '.ph-goals__tier{display:flex;align-items:center;gap:10px;font-size:.82rem;font-weight:600;color:var(--pg-muted);}',
      '.ph-goals__tier b{color:var(--pg-ink);font-weight:700;}',
      '.ph-goals__tier.is-on{color:var(--pg-ink);}',
      '.ph-goals__ico{width:20px;height:20px;flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;',
      'border-radius:50%;background:var(--pg-tile);color:var(--pg-muted);}',
      '.ph-goals__ico svg{width:12px;height:12px;}',
      '.ph-goals__tier.is-on .ph-goals__ico{background:rgba(18,161,80,.15);color:var(--pg-ok);}',
      '.ph-goals__gift{margin-top:14px;display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:13px;',
      'background:linear-gradient(180deg,rgba(15,154,250,.07),rgba(15,154,250,.03));border:1px solid rgba(15,154,250,.28);}',
      '.ph-goals__gift--ok{background:linear-gradient(180deg,rgba(18,161,80,.08),rgba(18,161,80,.03));border-color:rgba(18,161,80,.3);}',
      '.ph-goals__gift--ok>svg{color:var(--pg-ok);}',
      '.ph-goals__gift>svg{width:24px;height:24px;color:var(--pg-accent);flex:0 0 auto;}',
      '.ph-goals__gift-txt{flex:1 1 auto;min-width:0;font-size:.83rem;font-weight:700;color:var(--pg-ink);line-height:1.25;}',
      '.ph-goals__gift-txt span{display:block;font-weight:500;color:var(--pg-muted);font-size:.75rem;margin-top:2px;}',
      '.ph-goals__btn{flex:0 0 auto;border:0;border-radius:10px;padding:9px 16px;font:inherit;font-size:.8rem;font-weight:700;',
      'cursor:pointer;background:var(--pg-accent);color:#fff;transition:background .15s ease;white-space:nowrap;line-height:1;}',
      '.ph-goals__btn:hover{background:var(--pg-accent-dk);}',
      '.ph-goals__btn:disabled{opacity:.65;cursor:default;}',
      '.ph-goals__btn.is-added{background:var(--pg-ok);}',
      '.ph-goals__btn--ghost{background:transparent;color:var(--pg-muted);text-decoration:underline;padding:9px 6px;}',
      '.ph-goals__btn--ghost:hover{background:transparent;color:var(--pg-ink);}',
      '.ph-goals__nota{margin:11px 0 0;font-size:.72rem;color:var(--pg-muted);line-height:1.35;}',
      /* 17-08. El panel entra como primer hijo de la lista del cajon y la
         primera fila de producto quedaba pegada a el. Una linea fina y aire
         a los dos lados separan las dos cosas sin meter un bloque nuevo. */
      '[data-ph-goals] + *{margin-block-start:18px;padding-block-start:18px;border-block-start:1px solid rgba(13,20,32,.09);}'
    ].join('');
    var el = document.createElement('style');
    el.id = 'ph-cart-goals-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* ==========================================================================
     Contrato de carrito de Horizon
     ==========================================================================
     Horizon repinta el carrito escuchando `cart:update` y leyendo de ahi el HTML
     YA RENDERIZADO de las secciones (assets/component-cart-items.js,
     #handleCartUpdate). Si el evento no trae `detail.data.sections`, cae a
     renderSection(); y si no trae `detail` siquiera, revienta con TypeError.

     Asi que hay que hacer dos cosas, no una:
       1) pedir las secciones en la propia llamada (`sections` + `sections_url`),
          igual que hace Horizon en su updateQuantity();
       2) mandar el evento con la forma exacta que espera.
     ========================================================================== */

  function seccionesCarrito() {
    var ids = [];
    var nodos = document.querySelectorAll('cart-items-component[data-section-id]');
    for (var i = 0; i < nodos.length; i++) {
      var id = nodos[i].getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    }
    return ids;
  }

  /**
   * @param {object} cart      carrito de /cart.js, con `sections` pegado encima
   * @param {boolean} abrirDrawer  si false, se evita que el cajon se abra solo
   */
  function avisarCarrito(cart, abrirDrawer) {
    /* cart-drawer.js escucha el MISMO `cart:update` para abrirse cuando la
       tienda tiene auto_open_cart_drawer. Para un regalo que entra solo eso
       seria un salto de pantalla que el cliente no ha pedido: si esta en /cart
       subiendo una cantidad, se le abriria el cajon encima. Se le quita el
       atributo mientras dura el dispatch, que es sincrono, y se repone. */
    var drawer = document.querySelector('cart-drawer-component');
    var reponer = false;
    if (drawer && !abrirDrawer && drawer.hasAttribute('auto-open')) {
      drawer.removeAttribute('auto-open');
      reponer = true;
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'ph-cart-goals',
          data: {
            source: 'ph-cart-goals',
            itemCount: cart.item_count,
            sections: cart.sections
          }
        }
      }));
    } finally {
      if (reponer) drawer.setAttribute('auto-open', '');
    }
  }

  function getCart() {
    return fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { total_price: 0, items: [] }; })
      .catch(function () { return { total_price: 0, items: [] }; });
  }

  /**
   * Llama a /cart/add.js o /cart/change.js pidiendo las secciones, y avisa al
   * tema. Resuelve con el carrito actualizado.
   */
  function escribirCarrito(ruta, cuerpo, abrirDrawer) {
    var secciones = seccionesCarrito();
    if (secciones.length) {
      cuerpo.sections = secciones.join(',');
      cuerpo.sections_url = window.location.pathname;
    }
    return fetch(ROOT + ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'carrito');
          return d;
        });
      })
      .then(function (respuesta) {
        /* /cart/add.js devuelve el ITEM anadido, no el carrito, asi que el
           item_count y el total hay que pedirlos aparte. Las secciones si
           vienen en la respuesta y estan renderizadas DESPUES del cambio. */
        return getCart().then(function (cart) {
          cart.sections = respuesta.sections || null;
          avisarCarrito(cart, abrirDrawer);
          return cart;
        });
      });
  }

  /* Este helper lo llevaban buscando ph-upsells.js y el multipack desde el
     principio (`typeof window.phAddToCart === 'function'`), pero no lo definia
     nadie. Definiendolo aqui —este archivo se carga global desde ph-footer—
     esos modulos empiezan a refrescar el carrito bien sin tocarlos. */
  window.phAddToCart = function (items, origen, abrirDrawer) {
    return escribirCarrito('/cart/add.js', { items: items }, abrirDrawer !== false);
  };

  /* ==========================================================================
     Regalos: se anaden y se quitan solos
     ========================================================================== */

  /* Subtotal que cuenta para los umbrales. Se calcula SIN las lineas de regalo:
     si no, un regalo que Shopify no ha llegado a descontar (el caso de los dos
     BXGY) inflaria el total y desbloquearia el tramo siguiente el solo. */
  function baseCarrito(cart) {
    var total = 0;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (esRegalo(items[i].variant_id)) continue;
      total += Number(items[i].final_line_price) || 0;
    }
    return total;
  }

  function lineasRegalo(cart) {
    var mapa = {};
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (esRegalo(items[i].variant_id)) mapa[items[i].variant_id] = items[i];
    }
    return mapa;
  }

  /* Que regalos DEBERIA haber en la cesta con este subtotal. */
  function regalosQueTocan(base) {
    var desbloqueados = GIFTS.filter(function (g) { return base >= g.at; });
    if (!desbloqueados.length) return [];
    return ACUMULATIVOS ? desbloqueados : [desbloqueados[desbloqueados.length - 1]];
  }

  var reconciliando = false;
  var quitadosPorNosotros = {};
  var vistosAntes = null;

  /**
   * Compara lo que hay con lo que deberia haber y hace UN cambio por pasada.
   * Uno solo a proposito: cada escritura dispara cart:update, que vuelve a
   * llamar a render(), que vuelve a entrar aqui. Encadenar varios en la misma
   * pasada complica el control de reentrada sin ganar nada, porque son como
   * mucho dos.
   * @returns {Promise<boolean>} true si ha tocado el carrito
   */
  function gestionarRegalos(cart) {
    if (reconciliando) return Promise.resolve(false);

    var base = baseCarrito(cart);
    var dentro = lineasRegalo(cart);
    var tocan = regalosQueTocan(base);
    var tocanId = {};
    tocan.forEach(function (g) { tocanId[g.id] = true; });

    /* Si un regalo estaba y ha desaparecido sin que lo quitaramos nosotros, lo
       ha quitado el cliente. Se respeta durante toda la sesion. */
    if (vistosAntes) {
      for (var id in vistosAntes) {
        if (!vistosAntes[id]) continue;
        if (dentro[id]) continue;
        if (quitadosPorNosotros[id]) { delete quitadosPorNosotros[id]; continue; }
        rechazar(Number(id));
      }
    }
    vistosAntes = {};
    GIFTS.forEach(function (g) { vistosAntes[g.id] = !!dentro[g.id]; });

    /* 1) Sobra: o ya no se llega al minimo, o es el tramo bajo y solo cabe uno.
       Esto es lo que evitaba que al cliente le COBRARAN el overgrip al pasar de
       150 EUR, que es justo lo que se veia en el carrito de Raul. */
    var sobra = null;
    GIFTS.forEach(function (g) {
      if (dentro[g.id] && !tocanId[g.id]) sobra = g;
    });
    if (sobra) {
      reconciliando = true;
      quitadosPorNosotros[sobra.id] = true;
      return escribirCarrito('/cart/change.js', { id: dentro[sobra.id].key, quantity: 0 }, false)
        .then(function () { return true; })
        .catch(function () { delete quitadosPorNosotros[sobra.id]; return false; })
        .then(function (r) { reconciliando = false; return r; });
    }

    /* 2) Falta: desbloqueado, no esta dentro y no lo ha rechazado el cliente. */
    var falta = null;
    tocan.forEach(function (g) {
      if (!dentro[g.id] && !estaRechazado(g.id)) falta = g;
    });
    if (falta) {
      reconciliando = true;
      return escribirCarrito('/cart/add.js', { items: [{ id: falta.id, quantity: 1 }] }, false)
        .then(function () { return true; })
        .catch(function () { return false; })
        .then(function (r) { reconciliando = false; return r; });
    }

    /* 3) Cantidad: un regalo es 1, no 3. Si el cliente sube la cantidad de la
       linea, Shopify solo descuenta una unidad y le cobra el resto. */
    var pasado = null;
    tocan.forEach(function (g) {
      if (dentro[g.id] && dentro[g.id].quantity > 1) pasado = g;
    });
    if (pasado) {
      reconciliando = true;
      return escribirCarrito('/cart/change.js', { id: dentro[pasado.id].key, quantity: 1 }, false)
        .then(function () { return true; })
        .catch(function () { return false; })
        .then(function (r) { reconciliando = false; return r; });
    }

    return Promise.resolve(false);
  }

  function buildHtml(cart) {
    var total = baseCarrito(cart);
    var dentro = lineasRegalo(cart);

    var shipOk = total >= FREE_SHIP;
    var pct = Math.max(3, Math.min(100, Math.round((total / FREE_SHIP) * 100)));
    var falta = FREE_SHIP - total;

    /* 17-08. El mensaje decia "Suma un regalo si te queda margen", que no dice
       nada: ni que regalo, ni cuanto falta. Ahora, una vez conseguido el envio
       gratis, el objetivo pasa a ser el SIGUIENTE regalo y se dice cuanto queda.
       GIFTS esta ordenado de menor a mayor, asi que el primero por encima del
       total es el siguiente. */
    var siguiente = null;
    for (var gi = 0; gi < GIFTS.length; gi++) {
      if (total < GIFTS[gi].at) { siguiente = GIFTS[gi]; break; }
    }

    var msg;
    if (!shipOk) {
      msg = SHIP_SVG + '<span>Te faltan <b>' + euro(falta) + '</b> para el envío gratis</span>';
    } else if (siguiente) {
      msg = SHIP_SVG + '<span>Envío gratis conseguido. Te faltan <b>' +
        euro(siguiente.at - total) + '</b> para el siguiente regalo: <b>' +
        siguiente.label.toLowerCase() + '</b>.</span>';
    } else {
      msg = SHIP_SVG + '<span>Tienes el <b>envío gratis</b> y tu <b>regalo</b> incluido.</span>';
    }

    var tiers = GIFTS.map(function (g) {
      var on = total >= g.at;
      return '<li class="ph-goals__tier' + (on ? ' is-on' : '') + '">' +
        '<span class="ph-goals__ico">' + (on ? CHECK_SVG : LOCK_SVG) + '</span>' +
        '<span><b>' + euro(g.at) + '</b> &middot; ' + g.label.toLowerCase() + '</span></li>';
    }).join('');

    /* La caja de abajo ya no pide nada al cliente: informa. El regalo entra y
       sale solo (gestionarRegalos). El unico boton que queda es para recuperar
       un regalo que el cliente haya quitado a mano. */
    var giftBox = '';
    var tocan = regalosQueTocan(total);
    var puestos = tocan.filter(function (g) { return dentro[g.id]; });
    var rechazados = tocan.filter(function (g) { return !dentro[g.id] && estaRechazado(g.id); });

    if (puestos.length) {
      var nombres = puestos.map(function (g) { return g.label.toLowerCase(); }).join(' y ');
      giftBox = '<div class="ph-goals__gift ph-goals__gift--ok">' + GIFT_SVG +
        '<span class="ph-goals__gift-txt">Regalo incluido<span>' + nombres +
        ', ya está en tu pedido a 0 €</span></span></div>';
    } else if (rechazados.length) {
      var r = rechazados[rechazados.length - 1];
      giftBox = '<div class="ph-goals__gift">' + GIFT_SVG +
        '<span class="ph-goals__gift-txt">Tienes un regalo sin usar<span>' + r.label +
        ', gratis con tu pedido</span></span>' +
        '<button type="button" class="ph-goals__btn" data-ph-gift="' + r.id + '">Añadir</button></div>';
    }

    var nota = ACUMULATIVOS
      ? 'Los regalos se añaden solos al llegar a cada tramo. No pagas nada por ellos.'
      : 'El regalo se añade solo al llegar al mínimo. No pagas nada por él.';

    return '<div class="ph-goals' + (shipOk ? ' is-ship' : '') + '" data-ph-goals>' +
      '<p class="ph-goals__msg' + (shipOk ? ' is-ok' : '') + '">' + msg + '</p>' +
      '<div class="ph-goals__track"><div class="ph-goals__fill" style="width:' + pct + '%"></div></div>' +
      '<ul class="ph-goals__tiers">' + tiers + '</ul>' +
      '<p class="ph-goals__nota">' + nota + '</p>' +
      giftBox + '</div>';
  }

  function mountInto(container, cart) {
    if (!container) return;
    var old = container.querySelector(':scope > [data-ph-goals]');
    var wrap = document.createElement('div');
    wrap.innerHTML = buildHtml(cart);
    var node = wrap.firstChild;
    if (old) old.replaceWith(node); else container.insertBefore(node, container.firstChild);
  }

  function pintar(cart) {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      var host = drawer.querySelector('[ref="cartDrawerItems"], .cart-drawer__items, .drawer__inner, .cart-items') || drawer;
      mountInto(host, cart);
    }
    if (/\/cart\/?$/.test(window.location.pathname)) {
      var main = document.querySelector('cart-items-component, form[action$="/cart"], #main-cart-items, .cart__items');
      if (main) {
        var anchor = main.closest('[id^="shopify-section-"]') || main;
        var existing = document.querySelector('[data-ph-goals-page]');
        var box = document.createElement('div');
        box.setAttribute('data-ph-goals-page', '');
        box.innerHTML = buildHtml(cart);
        if (existing) existing.replaceWith(box);
        else anchor.parentNode.insertBefore(box, anchor);
      }
    }
  }

  function render() {
    return getCart().then(function (cart) {
      return gestionarRegalos(cart).then(function (cambiado) {
        /* Si hemos tocado el carrito, lo que teniamos ya no vale: se vuelve a
           pedir para pintar con lo que hay de verdad. El cart:update que
           disparo la escritura reentrara aqui, pero para entonces no habra
           nada que reconciliar y parara. */
        if (!cambiado) return pintar(cart);
        return getCart().then(pintar);
      });
    });
  }

  /* ---- recuperar un regalo quitado a mano ---- */
  document.addEventListener('click', function (ev) {
    var add = ev.target.closest('[data-ph-gift]');
    if (!add) return;
    ev.preventDefault();
    if (add.disabled) return;

    var id = Number(add.getAttribute('data-ph-gift'));
    /* Sacarlo de la lista de rechazados ANTES de anadir: si no, la siguiente
       pasada de gestionarRegalos lo volveria a considerar rechazado. */
    try {
      var arr = leerRechazados().filter(function (x) { return x !== id; });
      window.sessionStorage.setItem(CLAVE_RECHAZADOS, JSON.stringify(arr));
    } catch (e) {}

    add.disabled = true;
    add.textContent = 'Añadiendo…';
    escribirCarrito('/cart/add.js', { items: [{ id: id, quantity: 1 }] }, false)
      .then(function () { window.setTimeout(render, 120); })
      .catch(function () { add.disabled = false; add.textContent = 'Reintentar'; });
  });

  /* ---- init + reactividad ---- */
  function init() { injectStyle(); render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* `cart:refresh` no existe en Horizon (el unico evento de carrito es
     cart:update, ver assets/events.js). Se sigue escuchando porque otros
     modulos nuestros todavia lo disparan, pero ya no lo emitimos. */
  document.addEventListener('cart:update', function () { window.setTimeout(render, 80); });
  document.addEventListener('cart:refresh', function () { window.setTimeout(render, 80); });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(render, 80); });
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[href="#cart"], [data-cart-toggle], cart-drawer-component')) window.setTimeout(render, 200);
  });
})();
